import { z } from 'zod';

/** Public view of the tenant's FIB config (the secret is never returned). */
export interface FibSettings {
  hasSecret: boolean;
  clientId: string | null;
  baseUrl: string;
  realm: string;
  iqdRate: number;
  isActive: boolean;
  updatedAt: string;
}

export const FibSettingsUpdateSchema = z.object({
  clientId: z.string().max(191).nullable().optional(),
  /** Write-only — stored encrypted; omit to keep the existing secret. */
  clientSecret: z.string().max(500).optional(),
  baseUrl: z.string().url().max(191).optional(),
  realm: z.string().max(120).optional(),
  iqdRate: z.number().int().min(1).max(100000).optional(),
  isActive: z.boolean().optional(),
});
export type FibSettingsUpdate = z.infer<typeof FibSettingsUpdateSchema>;

/** Result of creating a FIB payment for an order — drives the pay screen. */
export interface FibPaymentResult {
  paymentId: string;
  qrCode: string | null;       // base64 data the storefront renders as a QR
  readableCode: string | null; // short code the customer can type in the FIB app
  paymentLink: string | null;  // personalAppLink (deep link to the FIB app)
  validUntil: string | null;
  amount: number;              // IQD
  currency: string;            // 'IQD'
  status: string;              // PENDING
}

/** Payment status poll result. */
export interface FibStatusResult {
  status: string; // PENDING | PAID | DECLINED
  paid: boolean;
}
